import React from "react";
import { RootStateOrAny, useSelector } from "react-redux";
// reactstrap components
import { CardBody, Col, Row } from "reactstrap";
import PackBoxCounter from "../Utilities/pack-box-counter";

interface CartProps {
	currency_symbol: string,
}

const CartItems: React.FC<CartProps> = ({ currency_symbol }) => {

	//Selectors
	const getProductState = store => store.cart.products

	//Redux Hooks
	const basket_establishment_id = useSelector((state: RootStateOrAny) => state.cart.establishment_id);
	const basket = useSelector((state: RootStateOrAny) => getProductState(state)) ?? [];

	const addons_list = (addons_product) => addons_product.map(d =>
		<h6 className="my-0 font-weight-light item-name">{d.name}: {d.addons.map(d => d.name + ', ')}</h6>
	)

	const calcPrice = (count, price, addons_product) => {
		let addons_cost = 0
		addons_product.map(d =>
			d.addons.map(d => addons_cost += parseInt(d.price))
		)
		return Number(((count* price) + addons_cost).toFixed(2));
	}

	return (
		<>
			{
				basket.map((product: any, i) => {
					const { name, id, is_veg, price, count, addons_product } = product;

					return (
						<Row className="flex-row flex-wrap shadow-0 py-2 px-3 border-bottom" key={i}>
							<Col className="p-0">
								<CardBody className="pl-2 pr-0 py-0 h-establishment">
									<h6 className="my-0 font-weight-bold item-name">{name} </h6>
									{addons_list(addons_product)}
									<div className="d-flex align-items-center justify-content-between text-muted pr-2 pt-1">
										<Col className="p-0 d-flex">
											<span className="mx-2">{currency_symbol} {price}</span>
										</Col>
									</div>
								</CardBody>
							</Col>
							<Col xs="3" className="text-center p-0 pt-1">
								<PackBoxCounter product={product} establishment_id={basket_establishment_id} hide_addon={true} />
							</Col>
							<Col xs="3" className="p-0 pt-1">
								<span className="p-1 text-dark text-right d-block">{currency_symbol} {calcPrice(count, price, addons_product)}</span>
							</Col>
						</Row>
					);
				})
			}
		</>
	)
};

export default CartItems;